export default __webpack_public_path__ + "static/media/9Aces_Banner_Color.0f7e5343.png";